import React from "react";
import { MultiSelect } from "react-multi-select-component";

const Filter = ({
  listOfOptionsList,
  onResetFilters,
  selected,
  setSelected,
  applyFilters
}) => {
  return (
    <div className="tw-w-full tw-md:w-2/3 tw-shadow tw-p-5 tw-rounded-sm tw-bg-white">
      <div className="tw-flex tw-items-center tw-justify-between">
        <p className="tw-font-medium">Filters</p>

        <button
          onClick={onResetFilters}
          className="tw-px-4 tw-py-2 tw-bg-gray-100 hover:tw-bg-gray-200 tw-text-gray-800 tw-text-sm tw-font-medium tw-rounded-md"
        >
          Reset Filters
        </button>
      </div>

      <div>
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 xl:tw-grid-cols-4 tw-gap-4 tw-mt-4">
          {listOfOptionsList.map((el, i) => (
            <div key={i}>
             <div className="tw-ml-1">{el.placeholder}</div>
              <MultiSelect
                hasSelectAll={false}
                disableSearch={true}
                options={el.options}
                value={selected[el.id]}
                onChange={value => {
                  setSelected(value, el.id);
                }}
                labelledBy="Select"
              />
            </div>
          ))}
        </div>
        <div className="tw-w-full tw-mt-2 tw-justify-end tw-flex">
          <button
            onClick={applyFilters}
            className="documentation__search-button btn ml-hf px-hf px-md-2"
          >
            Apply Filters
          </button>
        </div>
      </div>
    </div>
  );
};
export default Filter;
